import { render, staticRenderFns } from "./CompensationManagement.vue?vue&type=template&id=74946b40&scoped=true&"
import script from "./CompensationManagement.vue?vue&type=script&lang=js&"
export * from "./CompensationManagement.vue?vue&type=script&lang=js&"
import style0 from "./CompensationManagement.vue?vue&type=style&index=0&id=74946b40&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74946b40",
  null
  
)

export default component.exports